import Authenticator from '@/auth/Authenticator'
import * as types from './mutation_types'

let auth

function getAuthenticator () {
  if (!auth) {
    auth = new Authenticator()
  }
  return auth
}

export const login = () => {
  return new Promise((resolve) => {
    getAuthenticator().login()
    resolve()
  })
}

export const logout = ({ commit }) => {
  commit(types.AUTH_LOGOUT)
  return Promise.resolve()
}

export const handleAuthentication = ({ commit }) => {
  getAuthenticator().handleAuthentication().then(authResult => {
    commit(types.AUTH_AUTHENTICATED, authResult)
  }).catch(err => {
    console.log(err)
  })
}

export const checkSession = ({ commit, dispatch }) => {
  getAuthenticator().checkSession().then(authResult => {
    commit(types.UPDATE_TOKEN, authResult)
    return Promise.resolve()
  }).catch(() => {
    dispatch('login')
  })
}
